/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, isRejected } from "@reduxjs/toolkit";
import server from "api/server";

export const getPricingDetailsAction = createAsyncThunk(
  "getPricingDetails",

  async (payload: any) => {
    try {
      const { data } = await server.pricingDashboard.getPricingDetails(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getPricingFiltersAction = createAsyncThunk(
  "getPricingFiltersAction",

  async (payload: any) => {
    try {
      const { data } = await server.pricingDashboard.getPricingFiltersAction(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

// Working Slices
export const getPricingFiltersStatesAction = createAsyncThunk(
  "getPricingFiltersStatesAction",

  async (payload: any) => {
    try {
      const { data } = await server.pricingDashboard.getStates(payload);
      return data;
    } catch (error) {
      return isRejected(error);
    }
  },
);

export const getPricingRegionsHospitals = createAsyncThunk(
  "getPricingRegionsHospitals",

  async (payload: any) => {
    try {
      const { data } = await server.pricingDashboard.getRegionsAndHospitals(payload);
      return data;
    } catch (error) {
      return isRejected(error);
    }
  },
);

export const getPlanOptions = createAsyncThunk(
  "getPricingOptions",

  async () => {
    try {
      const { data } = await server.pricingDashboard.getPlans();
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getPurchaseMapping = createAsyncThunk(
  "getPurchaseMapping",

  async () => {
    try {
      const { data } = await server.pricingDashboard.getPlagetPurchaseMappingns();
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);
